import { Outlet } from "react-router-dom";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import SpinnerOverlay from "@components/ui/SpinnerOverlay";

export function ProtectedNoChromeLayout() {
  const isFetching = useIsFetching({
    predicate: (query) => !query.meta?.suppressGlobalLoader
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => !mutation.meta?.suppressGlobalLoader
  });
  const isLoading = isFetching > 0 || isMutating > 0;

  return (
    <>
      {isLoading && <SpinnerOverlay />}
      <Outlet />
    </>
  );
}
